import type { FaireProductEntity } from "../../entity_types/product";

export const nyc_snack_5: FaireProductEntity = {
  token: "nyc-snack-5",
  type: "product",
  name: "Gourmet Snack Mix",
  brandName: "Manhattan Snack Co.",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/88286f78cad0921e5e4940ca2f4cfc752fa0346cb502a79c1f621d15dec945eb.webp",
  priceDollars: 11,
  freeShipping: false,
  brandAvatarUrl:
    "https://cdn.prerelease.faire.dev/fastly/88286f78cad0921e5e4940ca2f4cfc752fa0346cb502a79c1f621d15dec945eb.webp",
  weight: 0.6,
  dimensions: {
    width: 5,
    height: 7,
    depth: 2,
  },
  description: "Premium snack mix with nuts, seeds, and dried fruit",
  categoryTokens: ["cat_food-snacks"],
  tags: ["nyc-local", "premium", "artisanal"],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-compass-migration",
  },
};
